import React, { useEffect, useState } from 'react';
import {
    Box, Grid, Typography, Rating, Avatar,
    Button,
    TablePagination
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import ReusableChip from '../../components/reusableComponents/chipSelector';
import { useSelector } from "react-redux";
import ApiService from '../../_services/ApiService';
import { getDateAsPerFormat, getTime } from '../../_helpers/reusablefunctions/dateSetter';
import { CardMediaSkeleton, CompactCardSkeleton } from '../../components/reusableComponents/SkeletonCard';

export default function MyReviews() {
    const [count, setCount] = useState(0);
    const [averageRating, setAverageRating] = useState(0);
    const [reviewData, setReviewData] = useState([]);
    const [data, setData] = useState([]);
    const userData = useSelector((state) => state.userData.userData);
    const [expandedReviews, setExpandedReviews] = useState({});
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        if (!userData?.id) return;
        const fetchBrandReview = async () => {
            setLoading(true);
            try {
                const response = await ApiService.get("all_ratings", {
                    brand_id: userData?.brand, limit: rowsPerPage,
                    offset: page * rowsPerPage,
                });
                setCount(response?.data?.count);
                setAverageRating(response?.data?.average_rating);
                setReviewData(response?.data?.results);
                setData(response?.data);
                console.debug("Response from all ratings", response?.data);

            } catch (error) {
                console.error("Failed to fetch influencer reviews", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBrandReview();
    }, [userData?.id, page, rowsPerPage]);

    const ratingsData = [
        { stars: 5, count: data.five?.percent },
        { stars: 4, count: data.four?.percent },
        { stars: 3, count: data.three?.percent },
        { stars: 2, count: data.two?.percent },
        { stars: 1, count: data.one?.percent },
    ];

    const handleExpand = (index) => {
        setExpandedReviews(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };

    return (
        <Box p={3}>
            <Box mb={2}><h1 className='fs-2'>Reviews</h1></Box>

            <Box p={2} sx={{ backgroundColor: '#FFFFFF', borderRadius: '8px' }}>
                {loading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                            <CompactCardSkeleton />
                        </Grid>
                    ))
                ) : (<Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ paddingLeft: '27px' }}>
                            <Typography paddingBottom={1} color="#7A7A7A" fontSize={"18px"}>
                                Your brand's rating and reviews from influencers
                            </Typography>
                            {ratingsData.map((item) => (
                                <Box display="flex" alignItems="center" key={item.stars} mb={1}>
                                    <Typography width={20}>{item.stars}</Typography>
                                    <StarIcon fontSize="small" sx={{ color: "#ffc107" }} />
                                    <Box flex={1} mx={1} height={10} bgcolor="#eee" borderRadius={5}>
                                        <Box
                                            // width={`${(item.count / count) * 100}%`}
                                            width={`${item.count}%`}
                                            height="100%"
                                            bgcolor="gold"
                                            borderRadius={5}
                                        />
                                    </Box>
                                    <Typography variant="body2" ml={1}>{item.count}%</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100%' }}>
                        <Typography color={"#030303"} fontSize={"77px"} fontWeight={600}>
                            {averageRating || 0}
                        </Typography>
                        <Rating value={averageRating} readOnly precision={0.5} />
                        <Typography color={"#7A7A7A"} fontSize={"15px"}>
                            {count} {count === 1 ? "Review" : "Reviews"}
                        </Typography>
                    </Grid>
                </Grid>)}
            </Box>

            <Box sx={{ backgroundColor: '#FFFFFF', borderRadius: '8px', padding: '16px 20px', margin: '20px 0 30px 0' }}>
                <Grid container spacing={2} alignItems="stretch">
                    {loading ? (
                        Array.from({ length: 8 }).map((_, i) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                                <CardMediaSkeleton />
                            </Grid>
                        ))
                    ) : (reviewData.length > 0 ? (
                        reviewData.map((review, index) => {
                            const date = getDateAsPerFormat(review?.created_at, 'DD Mon, YYYY');
                            const time = getTime(review?.created_at);
                            const isExpanded = expandedReviews[index];
                            return (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Box sx={{ border: "1px solid #D6D6D6", padding: '16px 20px', borderRadius: '8px', width: '100%', height: '100%' }}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: '100%' }}>
                                            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                                                <Avatar sx={{ width: 58, height: 58 }} src={review?.submission?.creator_logo} />
                                                <Box>
                                                    <Typography variant="h6" sx={{ fontSize: '14px', color: '#1A1A1A', fontWeight: 600 }}>
                                                        {review?.submission?.creator_handle_name}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: "#666" }}>
                                                        {review?.submission?.address}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <ReusableChip
                                                label={review?.submission?.creator_type}
                                                size="small"
                                                sx={{
                                                    border: '1px solid #ED3237',
                                                    color: '#ED3237',
                                                    fontSize: '11px',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#ffffff !important',
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ display: "flex", mt: 1 }}>
                                            <Typography sx={{ color: '#7A7A7A', fontSize: '12.19px', fontWeight: 400 }}>
                                                {date}
                                            </Typography>
                                        </Box>
                                        <Box mt={1} display={"flex"} flexDirection={"row"} gap={1}>
                                            <Rating value={review?.rating} size="small" readOnly precision={0.5} />
                                            <Typography sx={{ color: '#7A7A7A', fontSize: '12.19px', fontWeight: 400 }}> ({review?.rating} / 5)   </Typography>
                                        </Box>
                                        <Typography sx={{ color: '#454545', fontSize: '18px', fontWeight: 500 }}>
                                            Offer: {review?.submission?.campaign?.title}
                                        </Typography>
                                        <Typography sx={{ color: '#797979', fontSize: '16px', flexWrap: 'wrap', display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: isExpanded ? 'none' : 4, }}>
                                            {review.feedback}
                                        </Typography>

                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                                            {review.feedback?.length > 300 && (
                                                <Button onClick={() => handleExpand(index)} sx={{ fontSize: '12px', color: '#1A73E8', textTransform: 'none' }}>
                                                    {isExpanded ? 'View Less' : 'View More'}
                                                </Button>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>
                            )
                        })
                    ) : (
                        <Typography>No reviews available</Typography>
                    ))}
                </Grid>
                <Box display="flex" justifyContent="flex-end" mt={3}>
                    <TablePagination
                        component="div"
                        count={count}
                        page={page}
                        onPageChange={(e, newPage) => setPage(newPage)}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(e) => {
                            setRowsPerPage(parseInt(e.target.value, 10));
                            setPage(0);
                        }}
                        rowsPerPageOptions={[10, 20, 30]}
                        sx={{
                            "& .MuiTablePagination-selectLabel": {
                                paddingTop: '14px'
                            },
                            "& .MuiTablePagination-select": {
                                display: "inline-flex",
                                alignItems: "center",
                                paddingY: "0px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                margin: 0,
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}
